module.exports = __webpack_public_path__ + "static/img/banner-snbt.3d570a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-snbt.jpg
// module id = vhOJ
// module chunks = 1